class CbuzGallery extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-gallery-grid]');
    this.list = this.querySelector('[data-species-list]');
    this.empty = this.querySelector('[data-empty]');
    this.clearBtn = this.querySelector('[data-clear-filters]');
    this.lightbox = this.querySelector('[data-lightbox]');
    this.lbMedia = this.querySelector('[data-lightbox-media]');
    this.lbTitle = this.querySelector('[data-lightbox-title]');
    this.lbSub = this.querySelector('[data-lightbox-subheading]');
    this.lbDetails = this.querySelector('[data-lightbox-details]');
    this.lbDescription = this.querySelector('[data-lightbox-description]');
    this.lbClose = this.querySelector('[data-lightbox-close]');
    if (!this.list) return;

    this.items = this.grid ? Array.from(this.grid.querySelectorAll('.cbuz__item')) : [];
    this.buildFilterUI();
    this.bindEvents();
  }

  buildFilterUI() {
    const species = new Set();
    this.items.forEach(item => {
      const raw = (item.dataset.species || '').trim();
      if (!raw) return;
      raw.split(',').forEach(s => {
        const v = s.trim();
        if (v) species.add(v);
      });
    });
    const sorted = Array.from(species).sort();
    if (sorted.length === 0) {
      this.list.innerHTML = '<p style="margin:0;font-size:1.2rem;opacity:.7;">No species set yet.</p>';
      return;
    }
    this.list.innerHTML = sorted.map(s => `
      <label>
        <input type="checkbox" value="${this.escape(s)}" />
        <span>${this.escape(s)}</span>
      </label>
    `).join('');
  }

  bindEvents() {
    this.list.addEventListener('change', () => this.applyFilter());

    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', () => {
        this.list.querySelectorAll('input[type=checkbox]').forEach(cb => cb.checked = false);
        this.applyFilter();
      });
    }

    this.items.forEach(item => {
      const btn = item.querySelector('.cbuz__link');
      if (btn) {
        btn.addEventListener('click', (e) => {
          // If the tile is a real link, let the browser navigate to the page.
          if (btn.tagName === 'A' && btn.getAttribute('href')) return;
          e.preventDefault();
          this.openLightbox(btn);
        });
      }
    });

    if (this.lbClose) this.lbClose.addEventListener('click', () => this.closeLightbox());
    if (this.lightbox) {
      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox) this.closeLightbox();
      });
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.lightbox && !this.lightbox.hidden) this.closeLightbox();
    });
  }

  openLightbox(btn) {
    if (!this.lightbox || !this.lbMedia) return;

    const type = btn.dataset.type;
    const title = btn.dataset.title || '';
    const sub = btn.dataset.subheading || '';

    this.lbMedia.innerHTML = '';

    if (type === 'image') {
      const img = document.createElement('img');
      img.src = btn.dataset.largeImage;
      img.alt = title;
      this.lbMedia.appendChild(img);
    } else if (type === 'video') {
      const src = btn.dataset.videoSrc;
      const videoType = btn.dataset.videoType;
      const videoId = btn.dataset.videoId;

      if (src) {
        const video = document.createElement('video');
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        this.lbMedia.appendChild(video);
      } else if (videoType === 'youtube' && videoId) {
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        this.lbMedia.appendChild(iframe);
      } else if (videoType === 'vimeo' && videoId) {
        const iframe = document.createElement('iframe');
        iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        this.lbMedia.appendChild(iframe);
      }
    }

    if (this.lbTitle) { this.lbTitle.textContent = title; this.lbTitle.hidden = !title; }
    if (this.lbSub)   { this.lbSub.textContent = sub;     this.lbSub.hidden = !sub; }

    if (this.lbDetails) {
      const rows = [
        ['Genus', btn.dataset.genus],
        ['Species', btn.dataset.species],
        ['Hybrid', btn.dataset.hybrid],
        ['Seed parent', btn.dataset.seed],
        ['Pollen parent', btn.dataset.pollen],
      ].filter(([, v]) => v && v.trim());
      this.lbDetails.innerHTML = rows.map(([k, v]) =>
        `<div class="cbuz__lightbox-detail"><dt>${this.escape(k)}</dt><dd>${this.escape(v)}</dd></div>`
      ).join('');
      this.lbDetails.hidden = rows.length === 0;
    }

    if (this.lbDescription) {
      const description = btn.dataset.description || '';
      this.lbDescription.textContent = description;
      this.lbDescription.hidden = !description.trim();
    }

    this.lightbox.hidden = false;
    document.body.classList.add('cbuz-lock');
  }

  closeLightbox() {
    if (!this.lightbox) return;
    if (this.lbMedia) this.lbMedia.innerHTML = ''; // stop video playback
    this.lightbox.hidden = true;
    document.body.classList.remove('cbuz-lock');
  }

  applyFilter() {
    const active = Array.from(this.list.querySelectorAll('input[type=checkbox]:checked')).map(cb => cb.value.toLowerCase());
    let visibleCount = 0;
    this.items.forEach(item => {
      if (active.length === 0) {
        item.classList.remove('is-hidden');
        visibleCount++;
        return;
      }
      const itemSpecies = (item.dataset.species || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
      const match = active.some(a => itemSpecies.includes(a));
      item.classList.toggle('is-hidden', !match);
      if (match) visibleCount++;
    });
    if (this.empty) this.empty.hidden = visibleCount > 0;
  }

  escape(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }
}

if (!customElements.get('cbuz-gallery')) {
  customElements.define('cbuz-gallery', CbuzGallery);
}